export default __webpack_public_path__ + "static/media/Circles.ac94013f.svg";